"use strict";

(function () {
  'use strict';

  function moveModalsToBody(section) {
    section.querySelectorAll('.floating-boxes-modal-block__modal').forEach(function (modal) {
      if (modal.parentNode) {
        document.body.appendChild(modal);
      }
    });
  }
  function setNavState(viewport, prev, next) {
    var maxScroll = viewport.scrollWidth - viewport.clientWidth - 1;
    if (maxScroll <= 0) {
      prev.setAttribute('aria-disabled', 'true');
      next.setAttribute('aria-disabled', 'true');
      return;
    }
    var left = viewport.scrollLeft;
    prev.setAttribute('aria-disabled', left <= 1 ? 'true' : 'false');
    next.setAttribute('aria-disabled', left >= maxScroll ? 'true' : 'false');
  }
  function initCarousel(section) {
    var viewport = section.querySelector('.past-spotlight-carousel__viewport');
    var prev = section.querySelector('.past-spotlight-carousel__nav--prev');
    var next = section.querySelector('.past-spotlight-carousel__nav--next');
    if (!viewport || !prev || !next) {
      return;
    }
    function scrollByDirection(dir) {
      var delta = Math.max(viewport.clientWidth * 0.85, 240) * dir;
      viewport.scrollBy({
        left: delta,
        behavior: 'smooth'
      });
    }
    prev.addEventListener('click', function () {
      if (prev.getAttribute('aria-disabled') === 'true') {
        return;
      }
      scrollByDirection(-1);
    });
    next.addEventListener('click', function () {
      if (next.getAttribute('aria-disabled') === 'true') {
        return;
      }
      scrollByDirection(1);
    });
    viewport.addEventListener('scroll', function () {
      setNavState(viewport, prev, next);
    });
    window.addEventListener('resize', function () {
      setNavState(viewport, prev, next);
    }, {
      passive: true
    });
    setNavState(viewport, prev, next);
  }
  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-past-spotlight-carousel="1"]').forEach(function (section) {
      moveModalsToBody(section);
      initCarousel(section);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();